// ALL LOCALES
enum ELocale {
  FR = 'fr',
  EN = 'en',
  PL = 'pl',
  ES = 'es',
}

// PATIENT LOCALES
type TPatientLocale = ELocale
const PREFERED_LANGUAGE = ELocale.FR
const ENABLED_PATIENT_LOCALES = Object.values(ELocale)

// NAVIGATION LOCALES
type TNavigationLocales = ELocale.FR | ELocale.EN
const NAVIGATION_DEFAULT_LOCALE = ELocale.FR
const NAVIGATION_LOCALE_PREFIX = 'always' // Use the default: `always`
const NAVIGATION_LOCALES: TNavigationLocales[] = [ELocale.FR, ELocale.EN]

// LABELS
type TLabel = Partial<Record<TPatientLocale, string>>

export {
  ELocale,
  type TPatientLocale,
  PREFERED_LANGUAGE,
  ENABLED_PATIENT_LOCALES,
  type TNavigationLocales,
  NAVIGATION_DEFAULT_LOCALE,
  NAVIGATION_LOCALE_PREFIX,
  NAVIGATION_LOCALES,
  type TLabel,
}
